/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1VenueOrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MUTUALFUNDS_V1_VENUE_ORDER_EVENT_ENTITY_NAME = 'ixc.mutualfunds.v1.VenueOrderEvent';
export const ixcMutualfundsV1VenueOrderEventEntity = new schema.Entity<IxcMutualfundsV1VenueOrderEvent>(IXC_MUTUALFUNDS_V1_VENUE_ORDER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcMutualfundsV1VenueOrderEvent) => `${entity.metadata?.eventId}` });

